import React from 'react';
import Link from 'common/erm-components/basic/Link/Link';
import { getDocLink } from './DocLinkButton.info';

export const DocLinkButton: React.FC<{ docUrl: string, label: string }> = ({ docUrl, label }) => {
    return (
        <Link externalUrl={getDocLink(docUrl)} textProps={{ text: label }} buttonProps={{ color: 'brandPrimary' }} />
    );
};
